
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      // eslint-disable-next-line no-undef
      hbspt.forms.create({
        region: this.blok.region,
        portalId: this.blok.portal_id,
        formId: this.blok.form_id,
        target: '#hubspotemail-' + this.blok.form_id,
        onFormReady: () => {
          // target buttion and add classes
          const buttonEl = document.querySelector('.email-capture .hs-button')
          if (buttonEl) {
            buttonEl.classList.add(this.blok.button_color)
          }
        },
      })
    })
  },
}
